import { render, staticRenderFns } from "./Pump8ColumnTable.vue?vue&type=template&id=dbbf0ce2&scoped=true"
import script from "./Pump8ColumnTable.vue?vue&type=script&lang=js"
export * from "./Pump8ColumnTable.vue?vue&type=script&lang=js"
import style0 from "./Pump8ColumnTable.vue?vue&type=style&index=0&id=dbbf0ce2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbbf0ce2",
  null
  
)

export default component.exports